export const ARTICLES_PART5 = [
  {
    slug: "zima-v-almaty-chto-nosit",
    title: "Зима в Алматы: что носить в городе с горами за спиной",
    seoTitle: "Что носить зимой в Алматы — гид по верхней одежде | Angiolini",
    description:
      "Зима в Алматы — это -20°C утром и +5°C днём. Разбираем, какая шуба, пальто или пуховик реально работает в городе с резкой сменой погоды и горным ветром.",
    date: "2026-11-04",
    readTime: "6 мин",
    tag: "Алматы",
    image: "/media/articles/cover-coat-orange.webp",
    sections: [
      {
        h: "Почему зима в Алматы — особый вызов",
        ps: [
          "Алматы — единственный крупный город в Казахстане, где зимой можно за 3 часа перепрыгнуть 15 градусов: -18°C в Медеу, -5°C на Абая, +2°C на Розыбакиева. И везде ветер с гор, который «съедает» тепло любой некачественной верхней одежды.",
          "Именно поэтому здесь не работают шубы «на витрину» и красивые пуховики из масс-маркета. Нужна одежда, которая одновременно держит форму на променаде и защищает от алматинского сквозняка на парковке ТРЦ.",
        ],
      },
      {
        h: "Три сценария — три вещи",
        ps: [
          "Для ежедневных поездок в машине и коротких прогулок — кашемировое пальто длиной чуть выше колена. Не перегревается в тёплой машине, но держит форму и выглядит дорого.",
          "Для активной зимы (Медеу, Шымбулак, прогулки с детьми) — тёплый пуховик с лебяжьим пухом или натуральным гагачьим наполнителем. Лёгкий, тонкий, при этом выдерживает -25°C.",
          "Для вечеров и особых случаев — короткая шуба из норки, соболя или шиншиллы. В алматинскую сырую -8°C она греет лучше любого пуховика и держит любую метель.",
        ],
      },
      {
        h: "Что не работает в Алматы",
        ps: [
          "Длинные шубы «до пят» — красиво на фото, но неудобно в машине, а из-за талой соли на асфальте подол теряет вид за один сезон.",
          "Синтетические пуховики из масс-маркета — они не пропускают пар изнутри, вы потеете и через 15 минут на улице замерзаете сильнее, чем без пуховика.",
          "Тонкое драповое пальто без утеплителя — держит температуру только до -5°C, дальше ветер продувает насквозь.",
        ],
      },
      {
        h: "Как одеваются в Алматы те, кто знает",
        ps: [
          "Правило простое: одна вещь на каждый сценарий, но настоящая. Одна кашемировая пальто. Один пуховик на пух. Одна короткая шуба. Всё — итальянского пошива с честным составом на бирке.",
          "В приложении Angiolini собран каталог верхней одежды, отобранной под климат Алматы: только фабрики, которые работают с натуральными материалами и понимают, что такое -15°C с ветром.",
        ],
      },
    ],
  },

  {
    slug: "material-ili-brend-chto-vazhnee",
    title: "Материал или бренд: что на самом деле определяет, как вы выглядите",
    seoTitle: "Материал важнее бренда — почему ткань решает, а не логотип | Angiolini",
    description:
      "Бренд — это маркетинг. Материал — это то, что видит глаз через 5 секунд. Разбираем, почему пальто из настоящего кашемира от малоизвестной фабрики выглядит дороже, чем брендовое из шерсти.",
    date: "2026-11-08",
    readTime: "7 мин",
    tag: "Материалы",
    image: "/media/articles/cover-cashmere.webp",
    sections: [
      {
        h: "Что видит человек через 5 секунд",
        ps: [
          "Когда вы входите в комнату, никто не читает бирку на вашем пальто. Люди видят три вещи: как ткань лежит на плечах, как она отражает свет и как двигается при ходьбе. Всё это — свойства материала, не логотипа.",
          "Пальто из настоящего 100% кашемира двигается с телом, ложится мягкой волной, отражает свет глубоким матовым сиянием. Пальто из шерсти с добавлением полиэстера — держит форму «коробочки», блестит неровно и выдаёт своё происхождение с первого взгляда.",
        ],
      },
      {
        h: "Почему бренд перестал быть гарантией",
        ps: [
          "В 2010-х крупные модные дома массово переехали в производство в Азию и упростили составы ради маржи. Сегодня даже итальянский премиум-бренд может продавать пальто с составом «70% шерсть, 30% полиэстер» — при этом с прежним ценником.",
          "Малые итальянские фабрики, которые шьют для узкого круга бутиков, наоборот, сохранили высокие составы: 100% кашемир, 100% меринос, 100% альпака. Они не тратят миллионы на рекламу — вкладывают всё в материал.",
        ],
      },
      {
        h: "Как отличить настоящее от «псевдо-люкса»",
        ps: [
          "Возьмите край изделия в кулак и разожмите. Настоящий кашемир возвращается в форму медленно и мягко, оставляет тёплое ощущение в ладони. Шерсть с синтетикой хрустит и восстанавливается резко.",
          "Проверьте бирку состава — не марку, а именно состав. «Wool 100%» или «Cashmere 100%» — то, что надо. Всё, где стоят проценты полиэстера, акрила, вискозы — это компромисс.",
          "Посмотрите изнаночную сторону: у премиума швы обработаны атласной лентой или прикрыты подкладом; у масс-маркета швы открытые, с торчащими нитями.",
        ],
      },
      {
        h: "Почему Angiolini не гонится за брендами",
        ps: [
          "Мы работаем напрямую с итальянскими семейными фабриками, которые сохранили честные составы. У нас нет громких имён на этикетках — есть кашемир, который спустя 10 лет выглядит как в день покупки.",
          "Это и есть настоящий люкс — не логотип на видном месте, а материал, за который вам не будет стыдно ни через сезон, ни через десять.",
        ],
      },
    ],
  },

  {
    slug: "pochemu-mass-market-ne-prodaet-nastoyaschie-tkani",
    title: "Почему в масс-маркете не бывает настоящих тканей",
    seoTitle: "Почему масс-маркет не продаёт качественные ткани — экономика люкса | Angiolini",
    description:
      "Кашемир из козьего пуха с горного плато стоит от $200 за килограмм. Полиэстер — $2. Объясняем, почему масс-маркет физически не может продавать настоящие материалы.",
    date: "2026-11-11",
    readTime: "6 мин",
    tag: "Ткани",
    image: "/media/articles/cover-cashmere.webp",
    sections: [
      {
        h: "Математика тканей",
        ps: [
          "Килограмм настоящего внутреннемонгольского кашемира стоит около $180–220 за килограмм сырья. На одно пальто нужно 1.2–1.6 кг ткани. Только материал в пальто стоит $250+ до учёта пошива, логистики, налогов, аренды магазина.",
          "Полиэстер оптом стоит $1.80 за килограмм. Синтетическая шерстяная смесь — $8–12. Именно поэтому в масс-маркете пальто «под кашемир» может стоить $150 — но это физически не может быть кашемир.",
        ],
      },
      {
        h: "Почему это невозможно исправить",
        ps: [
          "Масс-маркет строит бизнес на объёме: чем больше вещей и чем ниже маржа, тем выгоднее. Дорогой материал в такой модели ломает всю экономику — не хватит покупателей.",
          "Кроме цены, есть скорость: настоящий кашемир требует медленной ручной обработки, аккуратного пошива, специальной глажки. Масс-маркет шьёт пальто за 12 минут на конвейере — для этого нужен полиэстер, который прощает грубую обработку.",
        ],
      },
      {
        h: "Куда идут настоящие ткани",
        ps: [
          "Всё лучшее сырьё выкупают заранее — итальянские, французские и японские фабрики бронируют партии за 2 года вперёд. К моменту, когда шерсть выходит на свободный рынок, там уже остаются только средние сорта.",
          "Именно поэтому серьёзные материалы почти не попадают в массовый ритейл — их скупают на этапе фермы. И ткани появляются только у брендов и ателье, которые работают напрямую с производителями.",
        ],
      },
      {
        h: "Что это значит для покупателя",
        ps: [
          "Если вы видите «100% кашемир» в масс-маркете за $80 — это либо не кашемир, либо переработанный (обрезки, пропущенные через машину). Такая ткань будет катышковаться через 2 недели.",
          "Настоящий кашемир, шерсть и мех продаются только через каналы, где заведомо ограниченный объём и высокая маржа — бутики, ателье, прямые контракты. Angiolini работает именно так.",
        ],
      },
    ],
  },

  {
    slug: "kashemir-nastoyaschiy-kak-otlichit",
    title: "Настоящий кашемир: как отличить его от подделки за 3 секунды",
    seoTitle: "Как отличить настоящий кашемир от подделки — 4 признака | Angiolini",
    description:
      "Настоящий кашемир — это козий пух с горных плато. Показываем 4 быстрых теста, которые отличают его от шерсти, полиэстера и «псевдо-кашемира» — прямо в примерочной.",
    date: "2026-11-15",
    readTime: "5 мин",
    tag: "Кашемир",
    image: "/media/articles/cover-cashmere.webp",
    sections: [
      {
        h: "Что такое настоящий кашемир",
        ps: [
          "Кашемир — это подшёрсток кашмирских коз, которые живут на плато Внутренней Монголии, Тибета и Ирана. С одной козы за год начёсывают всего 150–300 граммов пуха — этого хватает на треть свитера или четверть пальто. Отсюда и цена.",
          "Настоящий кашемир маркируется как «100% cashmere» или в смесях «wool + cashmere» с явно указанным процентом. Если стоит просто «Cashmere touch» или «Cashmere feel» — это маркетинг, ткани там нет.",
        ],
      },
      {
        h: "Тест №1 — ладонь",
        ps: [
          "Положите ладонь на ткань на 3 секунды и уберите. Настоящий кашемир мгновенно даёт тёплое, почти воздушное ощущение — как если бы вы коснулись пуховой подушки. Полиэстер холодный. Шерсть с добавками ощущается плотной и жестковатой.",
        ],
      },
      {
        h: "Тест №2 — свет",
        ps: [
          "Поверните ткань под углом к свету. Настоящий кашемир имеет глубокий матовый блеск с мягкими переливами. Полиэстер даёт «пластиковое» отражение, шерсть — сухой матовый цвет без глубины.",
        ],
      },
      {
        h: "Тест №3 — сминание",
        ps: [
          "Сожмите край ткани в кулаке на 5 секунд и разожмите. Кашемир возвращается в исходную форму медленно, ткань «дышит». Синтетика восстанавливается моментально и агрессивно. Шерсть остаётся немного примятой.",
        ],
      },
      {
        h: "Тест №4 — запах и волокна",
        ps: [
          "Настоящий кашемир — животный материал. Если понюхать вблизи, чувствуется лёгкий тёплый запах шерсти. Синтетика пахнет пластиком или ничем.",
          "Ещё один тест — посмотрите на волокна: у кашемира они длинные, тонкие, слегка волнистые. У переработанного «псевдо-кашемира» — короткие, обрывистые, разной длины.",
        ],
      },
      {
        h: "Что делать, если сомневаетесь",
        ps: [
          "В бутике Angiolini на каждом изделии есть полная спецификация состава и происхождения ткани. Мы работаем с фабриками, которые указывают конкретное плато, откуда пришёл кашемир — от Иккиина до Алашань.",
        ],
      },
    ],
  },

  {
    slug: "lebyazhiy-puh-i-drugie-napolniteli-puhovikov",
    title: "Лебяжий пух: почему изделия с ним весят как ничего и греют как шуба",
    seoTitle: "Лебяжий пух — почему он лучший наполнитель пуховика | Angiolini",
    description:
      "Разбираем, что такое лебяжий пух, почему он гипоаллергенен, как даёт эффект «пуховик как невесомость» и почему изделия Angiolini делаются именно на нём.",
    date: "2026-11-19",
    readTime: "6 мин",
    tag: "Пуховики",
    image: "/media/articles/cover-puffer-silver.webp",
    sections: [
      {
        h: "Что такое лебяжий пух",
        ps: [
          "Лебяжий пух — это ультратонкое полое волокно, созданное по образу и подобию настоящего пуха водоплавающих птиц, но полностью синтетическое и гипоаллергенное. Каждая нить внутри пустая — как микроскопический термос, который удерживает тёплый воздух вокруг тела и не выпускает его наружу.",
          "В премиальных итальянских пуховиках Angiolini лебяжий пух — основной наполнитель. Он позволяет создать вещь, которая одновременно ощущается невесомой и греет так, как обычно греет только тяжёлая шуба.",
        ],
      },
      {
        h: "Почему он гипоаллергенен",
        ps: [
          "Натуральный птичий пух — источник частой аллергии: перьевая пыль, следы биоматериала, клещи, которые живут в органическом наполнителе. У чувствительных людей это выражается насморком, слезами и зудом кожи.",
          "Лебяжий пух — 100% синтетическое волокно, в нём нет ни белков животного происхождения, ни органических остатков. Его можно стирать в машине, он не собирает пылевых клещей и подходит даже людям с астмой.",
        ],
      },
      {
        h: "Ощущение «невесомости»",
        ps: [
          "Плотность лебяжьего пуха в 3–4 раза ниже, чем у обычного синтепона. Пуховик до колена весит 350–500 граммов — как лёгкий шерстяной свитер. Вы надеваете его и через минуту забываете, что он на вас.",
          "Именно поэтому клиенты часто говорят: «Ощущение, будто на мне ничего нет — но при этом мне тепло и я выгляжу стильно». Это тот самый эффект, который невозможно получить от классического пуховика на птичьем пере — тот всегда чувствуется как вещь на плечах.",
        ],
      },
      {
        h: "Как он греет",
        ps: [
          "Полые волокна лебяжьего пуха задерживают в 5–6 раз больше воздуха, чем плотные синтетические утеплители. Именно эти микро-подушки тёплого воздуха и работают как защита от холода — они не пропускают тепло тела наружу и не впускают морозный воздух внутрь.",
          "На практике лебяжий пух комфортен до -25°C. То есть с ним вы можете уверенно ехать на Медеу, гулять с детьми по Розыбакиева зимой, стоять на морозной парковке — и оставаться в тепле. При этом пуховик не давит на плечи и не сковывает движения.",
        ],
      },
      {
        h: "Почему лебяжий пух не боится Алматы",
        ps: [
          "В Алматы зимой сыро: тающий снег, дождь со снегом, слякоть. Натуральный пух в такой погоде теряет свои свойства — сваливается, комкается, требует химчистки после каждого сезона.",
          "Лебяжий пух не боится влаги. Стирается в машине на деликатном режиме, восстанавливает форму сразу после сушки. Один и тот же пуховик служит 8–10 сезонов без потери тепла и объёма.",
        ],
      },
      {
        h: "Как отличить настоящий лебяжий пух",
        ps: [
          "Прощупайте наполнитель: настоящий лебяжий пух ощущается как облако — мягкий, воздушный, без «жёстких» зон. Дешёвый синтепон комкуется и даёт неоднородную плотность.",
          "Взвесьте изделие: пуховик длиной до колена на лебяжьем пухе весит 350–500 граммов. Если весит 800+ граммов — это, скорее всего, обычный синтепон под маркетинговым названием.",
          "Посмотрите на посадку: лебяжий пух даёт мягкий, «дышащий» силуэт без «раздутых квадратов». Пуховик садится по фигуре, а не превращает вас в бочонок.",
        ],
      },
      {
        h: "Пуховики Angiolini",
        ps: [
          "Все пуховики в коллекции Angiolini делаются итальянскими фабриками на лебяжьем пуху. Мы сознательно выбрали этот наполнитель — он лучше всего подходит для алматинской зимы, гипоаллергенен и создаёт то самое ощущение невесомости, за которым к нам возвращаются клиенты.",
          "Записаться на примерку или получить консультацию стилиста можно через WhatsApp — подберём модель под ваш рост, размер и стиль жизни.",
        ],
      },
    ],
  },

  {
    slug: "palto-s-mehom-glavnyi-trend-zimy",
    title: "Пальто с мехом: главный тренд зимы и как носить его в Алматы",
    seoTitle: "Пальто с меховым воротником — как носить и с чем сочетать | Angiolini",
    description:
      "Пальто с меховым воротником — самый практичный тренд этой зимы. Разбираем, какие меха выбирать, как отличить настоящий от искусственного и с чем носить в городе.",
    date: "2026-11-22",
    readTime: "6 мин",
    tag: "Пальто",
    image: "/media/articles/cover-coat-orange.webp",
    sections: [
      {
        h: "Почему пальто с мехом снова в моде",
        ps: [
          "Полноценная шуба — вещь для случаев. Пальто без меха — не выглядит зимним. Пальто с меховым воротником или манжетами закрывает эту дыру: тепло, стильно, уместно на работе, в машине, на прогулке и в ресторане.",
          "В сезоне 2026/27 итальянские дома масштабно вернулись к этому силуэту — с натуральной норкой, лисой, соболем или каракулем на воротнике. Оранжевые, изумрудные и глубокие бордовые тона — фаворит сезона.",
        ],
      },
      {
        h: "Какой мех выбирать",
        ps: [
          "Норка — самый универсальный выбор. Не боится дождя и снега, держит форму, лёгкий. Идеален для повседневных пальто.",
          "Соболь — премиум-вариант. Даёт глубокий переливающийся блеск, воротник выглядит «дороже пальто». Требует бережного отношения.",
          "Каракульча — плоский мех с завитком, добавляет графичности силуэту. Хорошо смотрится на пальто прямого кроя.",
          "Лиса — для тех, кто хочет драмы: пышный, объёмный воротник, который сразу привлекает внимание. Не для минимализма.",
        ],
      },
      {
        h: "Как отличить настоящий мех от искусственного",
        ps: [
          "Раздвиньте волоски у основания. У настоящего меха вы увидите кожаную основу (мездру) телесного цвета. У искусственного — тканевую основу.",
          "Проведите пальцами против шерсти: настоящий мех возвращается в форму мягкой волной, искусственный — резким скачком.",
          "Подожгите один волосок (осторожно): настоящий волос пахнет палёными волосами, синтетика — плавленым пластиком.",
        ],
      },
      {
        h: "С чем носить в Алматы",
        ps: [
          "С джинсами и высокими сапогами — самая универсальная связка на каждый день.",
          "С прямыми брюками и лоферами — для офиса и деловых встреч. Особенно хорошо смотрится с классическим пальто с норковым воротником.",
          "С миди-платьем и колготками — вечерний вариант. Меховой воротник заменит украшение на шее.",
        ],
      },
      {
        h: "Что есть в коллекции Angiolini",
        ps: [
          "У нас в бутике представлены пальто с меховыми воротниками из норки, соболя и каракульчи — все от итальянских семейных ателье. Каждое пальто идёт с сертификатом происхождения меха и ткани.",
        ],
      },
    ],
  },

  {
    slug: "shinshilla-samyi-dorogoi-mekh",
    title: "Шиншилла: почему это самый дорогой мех в мире",
    seoTitle: "Шуба из шиншиллы — почему это самый дорогой мех | Angiolini",
    description:
      "Шиншилла — мех, у которого 60–80 волосков растёт из одной поры. Разбираем, откуда такая цена, как отличить настоящую шиншиллу и почему её носят королевские дома.",
    date: "2026-11-26",
    readTime: "6 мин",
    tag: "Шиншилла",
    image: "/media/articles/cover-chinchilla.webp",
    sections: [
      {
        h: "Что делает шиншиллу уникальной",
        ps: [
          "У большинства животных из одной поры кожи растёт 1 волосок. У соболя — до 20. У шиншиллы — 60–80. Такая плотность подшёрстка не встречается больше нигде в природе.",
          "Именно поэтому шуба из шиншиллы даёт эффект «облака» — она визуально в 3 раза объёмнее, чем от того же объёма норки, а по весу вдвое легче.",
        ],
      },
      {
        h: "Откуда берётся шиншилла",
        ps: [
          "Историческая родина — горные Анды в Чили и Перу. В дикой природе шиншилла живёт на высоте 3000–5000 метров, где температура падает до -30°C — отсюда и уникально густой мех.",
          "Сегодня 100% шиншиллы для шуб выращивается на ферме, преимущественно в Дании, Северной Америке и Аргентине. Одна шкурка занимает 1.5 года выращивания.",
        ],
      },
      {
        h: "Сколько нужно шкурок на одну шубу",
        ps: [
          "На короткое болеро уходит 40–50 шкурок. На классическую шубу до колена — 100–130. Каждая шкурка размером с ладонь, стоит на аукционе в Копенгагене от $200 до $600.",
          "Плюс работа мастера: соединить 100+ мелких шкурок в единое полотно с сохранением рисунка — 200+ часов ручной работы. Отсюда цена финальной шубы от 4 до 15 миллионов тенге.",
        ],
      },
      {
        h: "Как отличить настоящую шиншиллу",
        ps: [
          "Настоящая шиншилла имеет фирменный трёхцветный рисунок волоса: чёрный кончик, белая середина, тёмно-серое основание. Синтетика или крашеный кролик — однотонные.",
          "Погладьте против шерсти: шиншилла даёт визуальный эффект «прохладной волны» — из-за плотности волосков вы видите переливающийся серебристый оттенок.",
          "Настоящий мех невероятно лёгкий. Шуба до колена весит меньше, чем норковая жилетка — если чувствуете тяжесть, это не шиншилла.",
        ],
      },
      {
        h: "Почему шиншиллу выбирает люкс",
        ps: [
          "Шиншилла — единственный мех, который не рекомендуется носить каждый день. Слишком нежный подшёрсток стирается от постоянного контакта с одеждой. Именно поэтому шиншилла — статусная вещь для особых случаев.",
          "В Angiolini мы работаем с двумя итальянскими ателье, которые специализируются на шиншилле — их изделия можно увидеть в бутике по записи. Каждое изделие проходит финальную посадку по фигуре клиента.",
        ],
      },
    ],
  },

  {
    slug: "fabrika-kotoraya-znaet-svoego-klienta",
    title: "Почему только фабрики, знающие своего клиента, шьют из лучших материалов",
    seoTitle: "Почему малые фабрики шьют из лучших материалов — экономика люкса | Angiolini",
    description:
      "Крупные бренды упрощают составы ради маржи. Малые семейные фабрики Италии сохраняют честные материалы, потому что знают каждого своего клиента лично.",
    date: "2026-11-30",
    readTime: "6 мин",
    tag: "Италия",
    image: "/media/articles/cover-sable.webp",
    sections: [
      {
        h: "Почему это работает именно так",
        ps: [
          "Крупный бренд делает 500 000 пальто в год. Ему не важно, вернётся ли конкретный покупатель — на его место придёт другой. Экономия $10 на составе × 500 000 = $5 миллионов дополнительной прибыли. Соблазн непреодолимый.",
          "Малая итальянская фабрика делает 800 пальто в год для узкого круга бутиков. Каждый клиент — на счету. Если он купит пальто, которое расползётся через сезон, он уйдёт к конкуренту и заберёт с собой репутацию — а с ней ещё 10 клиентов.",
        ],
      },
      {
        h: "Как это меняет производство",
        ps: [
          "Малые фабрики не могут позволить себе плохой материал: слишком дорога потеря клиента. Они заранее покупают лучшее сырьё, сохраняют ручной пошив, платят опытным мастерам-скорнякам.",
          "У большинства таких ателье в Италии — свои посадчики, которые вручную «строят» пальто на манекенах разных фигур. Стандартных размеров у них нет — есть система подгонки под тело.",
        ],
      },
      {
        h: "Почему их не найти в масс-маркете",
        ps: [
          "Малая фабрика физически не может отгружать десятки тысяч изделий в сезон. Она работает с 15–30 бутиками по миру — каждый берёт по 20–50 моделей. Клиенты приходят через сарафанное радио и репутацию.",
          "Именно поэтому их брендов вы не увидите в рекламе. Они не тратят на маркетинг — вкладывают в материал и мастерство. Их клиент — тот, кто уже понимает разницу.",
        ],
      },
      {
        h: "Как Angiolini выбирает фабрики",
        ps: [
          "Мы работаем только с семейными ателье, где владелец фабрики лично контролирует каждую партию. Все наши поставщики — 3-е или 4-е поколение мастеров, ни одна модель не запускается в производство без ручного прототипа.",
          "Это медленнее, дороже и сложнее логистически. Зато мы можем гарантировать состав, происхождение и мастерство каждого изделия — по имени фабрики и мастера.",
        ],
      },
    ],
  },

  {
    slug: "pochemu-italyanskiy-poshiv-otlichaetsya",
    title: "Почему итальянский пошив ощущается по-другому: 7 деталей",
    seoTitle: "Итальянский пошив — 7 деталей, которые отличают его от массового | Angiolini",
    description:
      "Что именно делают итальянские мастера, чего не делают в массовом производстве. Разбираем 7 конкретных деталей — от плечевого шва до подкладки.",
    date: "2026-12-03",
    readTime: "7 мин",
    tag: "Пошив",
    image: "/media/articles/cover-sable.webp",
    sections: [
      {
        h: "Плечевой шов — сердце пальто",
        ps: [
          "В итальянском пошиве плечо строится вручную с использованием «prosciutto» — специальной подушки для пропаривания. Плечо получается округлым, без «квадрата», ложится по анатомии.",
          "В масс-маркете плечо просто прострачивается на машине. Отсюда «коробочный» силуэт, который читается за 10 метров.",
        ],
      },
      {
        h: "Внутренняя структура — халф-канвас",
        ps: [
          "Между тканью и подкладкой в итальянском пальто идёт слой канваса (жёсткой основы) — вручную пришитой мелкими стежками. Он держит форму, но при этом даёт ткани дышать.",
          "В массовом производстве канвас приклеивается на клей. Через 2–3 химчистки клей отходит, ткань пузырится — вы видите это на пальто, где грудь и лацканы «отходят» волнами.",
        ],
      },
      {
        h: "Подкладка — не просто ткань",
        ps: [
          "У итальянских ателье подкладка почти всегда — купро (Bemberg) или шёлк. Она не электризуется, не липнет к телу, скользит при надевании поверх свитера.",
          "Полиэстеровая подкладка масс-маркета — прилипает к телу, электризуется, из-за неё пальто «садится» криво.",
        ],
      },
      {
        h: "Пуговицы и застёжки",
        ps: [
          "Пуговицы у итальянцев — рог, перламутр или дерево. Пришиваются с «ножкой» из ниток длиной 3–5 мм, чтобы ткань могла двигаться без деформации.",
          "В массе — пластмасса, пришитая впритык. Через сезон отрывается или деформирует ткань вокруг петли.",
        ],
      },
      {
        h: "Швы, которых не видно",
        ps: [
          "У итальянцев внутренние швы обработаны атласной лентой или обмётаны вручную. Изнанка выглядит так же аккуратно, как лицо.",
          "У масс-маркета изнанка открытая, с торчащими нитями и грубыми оверлочными строчками.",
        ],
      },
      {
        h: "Разутюжка — 5 часов работы",
        ps: [
          "Каждый шов итальянского пальто отдельно отпаривается и разутюживается вручную. Общее время на глажку одного пальто — 4–5 часов. За счёт этого ткань «дышит», не залоснивается на сгибах, силуэт держится годами.",
        ],
      },
      {
        h: "Финальная примерка",
        ps: [
          "Каждое итальянское пальто проходит финальную примерку на манекене-«портном» — восковой фигуре, повторяющей анатомию женского тела. Ошибки в посадке видны сразу и исправляются вручную.",
          "В коллекции Angiolini все изделия отбирались на этапе финальной примерки — мы видели каждое пальто на манекене до того, как оно попало в бутик Алматы.",
        ],
      },
    ],
  },

  {
    slug: "kak-vybrat-shubu-na-vsyu-zhizn",
    title: "Как выбрать шубу, которая прослужит 15 лет и станет наследством",
    seoTitle: "Как выбрать шубу на всю жизнь — 8 правил | Angiolini",
    description:
      "Настоящая шуба — это инвестиция на 15–20 лет, а иногда и наследство для дочери. 8 конкретных правил, которые помогут не ошибиться в бутике.",
    date: "2026-12-06",
    readTime: "8 мин",
    tag: "Шубы",
    image: "/media/articles/cover-sable.webp",
    sections: [
      {
        h: "Правило 1. Выбирайте по меху, не по цене",
        ps: [
          "Соболь, норка, шиншилла — единственные меха, которые уверенно живут 15+ сезонов при правильном хранении. Каракульча — 12. Лиса и енот — 6–8. Кролик и бобр — максимум 4.",
          "Ставьте бюджет из расчёта «на 15 лет носки». Тогда шуба из норки за 3 миллиона тенге стоит 200 000 в год — дешевле любого качественного пальто.",
        ],
      },
      {
        h: "Правило 2. Проверьте мездру",
        ps: [
          "Раздвиньте мех у подола и посмотрите на изнаночную сторону кожи. Она должна быть тонкой, мягкой, эластичной, ровного бежевого цвета — как замша.",
          "Жёсткая, толстая или бумажно-сухая мездра означает нарушение выделки. Через 2–3 года такая шуба начнёт лопаться по швам.",
        ],
      },
      {
        h: "Правило 3. Посмотрите на подшёрсток",
        ps: [
          "Подшёрсток должен быть густым, равномерным, без «проплешин». Слегка подуйте на мех — увидите плотное «облако» пуха под остью.",
          "Если ость раздвигается и вы видите голую мездру — это отбраковка, которую пустили в продажу.",
        ],
      },
      {
        h: "Правило 4. Проверьте длину волоса",
        ps: [
          "Волос по всей шубе должен быть одинаковой длины. Проведите ладонью по разным частям — если чувствуете «ступеньки», значит скорняк смешал шкурки разных категорий.",
        ],
      },
      {
        h: "Правило 5. Оцените швы",
        ps: [
          "Разверните подол и посмотрите с изнанки: швы между шкурками должны быть тонкими, ровными, без утолщений. Толстые нитки, узлы и «пропуски» — брак.",
          "Хороший скорняк соединяет шкурки так, что снаружи вы не видите линий сшива вообще.",
        ],
      },
      {
        h: "Правило 6. Проверьте посадку",
        ps: [
          "Наденьте шубу и поднимите руки, пожмите плечами, присядьте. Она не должна тянуть в плечах, задираться на спине, вставать «коробкой» на груди.",
          "Итальянская шуба должна двигаться с телом — это результат правильного кроя и посадки на манекене.",
        ],
      },
      {
        h: "Правило 7. Требуйте сертификат",
        ps: [
          "У каждой премиум-шубы должен быть сертификат: происхождение меха, номер шкурок, категория, страна выделки. Если продавец не может показать сертификат — уходите.",
          "У изделий Angiolini на каждой шубе есть карточка с историей: ферма, аукцион, мастерская, скорняк, дата пошива.",
        ],
      },
      {
        h: "Правило 8. Не экономьте на итальянском пошиве",
        ps: [
          "Хороший мех + плохой пошив = деньги на ветер. Итальянские ателье — единственные в мире, кто на протяжении 100+ лет непрерывно передаёт секреты меховой работы из поколения в поколение.",
          "Angiolini работает только с итальянскими мастерами — от Милана до Флоренции. Все шубы в коллекции прошли ручной пошив и финальную посадку.",
        ],
      },
    ],
  },
];
